import React, { createContext, useContext, ReactNode } from 'react';
import { useInsuranceState } from './state';

// 創建一個 Context
const StateContext = createContext<ReturnType<typeof useInsuranceState> | undefined>(undefined);

// Provider 組件
interface StateProviderProps {
  children: ReactNode;
}

export const StateProvider: React.FC<StateProviderProps> = ({ children }) => {
  const state = useInsuranceState();
  
  return (
    <StateContext.Provider value={state}>
      {children}
    </StateContext.Provider>
  );
};

// 自定義 Hook 讓組件可以輕鬆訪問狀態
export const useAppState = () => {
  const context = useContext(StateContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within a StateProvider');
  }
  return context;
};
